module.exports = __webpack_public_path__ + "img/gwnu_gallery8.a27200a7.jpg";